import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { router } from "./routes/router";
import AntdThemeWrapper from "./components/shared/AntdThemeWrapper/index";
import { store } from "./store";
import "./assets/styles/global.css";
const App = () => {
  return (
    <Provider store={store}>
      <AntdThemeWrapper>
        <RouterProvider router={router} />
      </AntdThemeWrapper>
    </Provider>
  );
};

export default App;
